module.exports = __webpack_public_path__ + "img/solomon-islands.51b4e2a1.png";